var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBenefitEditIcon = function SvgBenefitEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#benefit_editIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.501,
    y: 0.742,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.14 18.979c-.058.058-.058.087-.058.146v3.34H11.77V12.152h7.09c.058 0 .088 0 .146-.058l.938-.938c.058-.058.087-.146.058-.263-.058-.088-.117-.147-.205-.147H11.77c-.41 0-.733.147-.996.41-.293.293-.41.615-.41.996v10.313c0 .41.117.732.41.996.263.293.586.41.996.41h10.312c.381 0 .703-.117.996-.41.264-.264.41-.586.41-.996v-4.248c0-.117-.058-.176-.146-.235-.117-.029-.205 0-.264.059l-.937.938Zm4.6-5.918a1.66 1.66 0 0 0 .498-1.202c0-.468-.175-.879-.498-1.23l-1.26-1.26c-.35-.322-.761-.498-1.23-.498a1.66 1.66 0 0 0-1.201.498l-7.705 7.705-.293 2.637c-.059.41.059.732.351.996.264.293.587.41.997.352l2.636-.293 7.705-7.705Zm-2.9.908-5.45 5.449-1.904.205.206-1.904 5.449-5.45 1.699 1.7Zm1.904-2.344a.333.333 0 0 1 .088.234c0 .088-.03.147-.088.206l-.908.908-1.7-1.7.91-.908a.266.266 0 0 1 .204-.088c.088 0 .176.03.235.088l1.26 1.26Z",
    fill: "#333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "benefit_editIcon_svg__a",
    x: 0.501,
    y: 0.742,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20011_86070"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_20011_86070",
    result: "shape"
  })))));
};

export default SvgBenefitEditIcon;